<template>
    <div>
        <div class="c-box c-box--alpha">
            <div class="c-box__header">
                <div class="c-box__title">
                    Account system restart
                </div>
            </div>
            <div class="c-box__content">
                <b-container>
                    <b-row>
                        <b-col>
                            <b-button variant="info" @click="restartSystem()">Restart system</b-button>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row v-if="is_restarting">
                        <b-col>
                            <loader>System is restarting</loader>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </div>
        <account-system-restart-ccs-modal></account-system-restart-ccs-modal>
    </div>
</template>

<script>
    import CcsModal from "@/components/CcsModal.vue";


    export default {
        components: {
            AccountSystemRestartCcsModal: CcsModal,
        },

        name: "AccountSystemRestart",

        metaInfo: {
            title: "AccountSystemRestart"
        },

        props: {},

        data: function () {
            return {
                unique_process_id: -1,
                check_unique_process_id: -1,

                is_restarting: false,

                check_account_engine_restart: null,
            }
        },
        created() {
        },
        ready: function () {
        },
        mounted() {
        },
        watch: {},
        computed: {},
        methods: {
            checkIfRestarted() {
                this.$store
                    .dispatch("utilities/GetAccountPid")
                    .then(
                        (success_data) => {
                            this.check_unique_process_id = success_data;
                            if(this.check_unique_process_id != -1 && this.unique_process_id == this.check_unique_process_id)
                            {
                                this.unique_process_id = -1;
                                this.check_unique_process_id = -1;
                            }
                            else
                            {
                                this.is_restarting = false;
                                clearTimeout(this.check_account_engine_restart);
                                this.check_account_engine_restart = null;
                                this.$notify({
                                    type: "success",
                                    title: "System restart success",
                                    text: ""
                                });

                                location.reload();
                            }
                        },
                        (error_data) => {
                            this.check_account_engine_restart = setTimeout(this.checkIfRestarted, 5000);

                            // console.log(error_data);
                            // this.$modal.show("account-system-restart-ccs-modal-dialog", {
                            //     type: "error",
                            //     title: "Error restarting system",
                            //     text: error_data,
                            //     buttons: [
                            //         {
                            //             title: "Close",
                            //             default: true // Will be triggered by default if 'Enter' pressed.
                            //         }
                            //     ]
                            // });
                            return;
                        }
                    );
            },

            restartSystem() {
                this.$store
                    .dispatch("utilities/GetAccountPid")
                    .then(
                        (success_data) => {
                            this.unique_process_id = success_data;
                            if(this.unique_process_id != -1)
                            {
                                this.$store
                                    .dispatch("utilities/AccountSystemRestart")
                                    .then(
                                        (success_data) => {
                                            this.is_restarting = true;
                                            this.check_account_engine_restart = setTimeout(this.checkIfRestarted, 5000);
                                        },
                                        (error_data) => {
                                            this.unique_process_id = -1;
                                            this.is_restarting = false;

                                            this.$modal.show("account-system-restart-ccs-modal-dialog", {
                                                type: "error",
                                                title: "Error restarting system",
                                                text: error_data,
                                                buttons: [
                                                    {
                                                        title: "Close",
                                                        default: true // Will be triggered by default if 'Enter' pressed.
                                                    }
                                                ]
                                            });
                                            return;
                                        }
                                    );
                            }
                            else
                            {
                                this.$notify({
                                    type: "error",
                                    title: "System restart failed",
                                    text: ""
                                });
                            }
                        },
                        (error_data) => {
                            console.log(error_data);
                            this.unique_process_id = -1;
                            this.is_restarting = false;

                            this.$modal.show("account-system-restart-ccs-modal-dialog", {
                                type: "error",
                                title: "Error fetching account system PID",
                                text: error_data,
                                buttons: [
                                    {
                                        title: "Close",
                                        default: true // Will be triggered by default if 'Enter' pressed.
                                    }
                                ]
                            });
                            return;
                        }
                    );
            },
        },

        destroyed() {
            clearTimeout(this.check_account_engine_restart);
            this.check_account_engine_restart = null;
        },
    }



</script>

<style scoped>

</style>